import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { isUatEnvironment } from '../../helpers/uatMasking';
import { Pagination } from '@mui/material';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, MenuItem, Typography, FormControl, TextField, CardActions, Modal, Box, Select, InputLabel, Divider, Backdrop, CircularProgress, Stack, Chip } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import OperationsHeader from './OperationsHeader';
import { DataGrid, GridCellParams, GridRowParams } from '@mui/x-data-grid';
import { EditOutlined, CloseOutlined } from '@mui/icons-material';
import debounce from 'lodash.debounce';
function CustomPagination({ count, page, onChange }: { count: number, page: number, onChange: (event: React.ChangeEvent<unknown>, value: number) => void }) {
  return (
      <Pagination
          count={count}
          page={page}
          onChange={onChange}
          color="primary"
          shape="rounded"
          variant="outlined"
          showFirstButton
          showLastButton
      
      
      
      />
  );
} 
const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '65%',
  p: 4,
};

export interface IProps {
  user: {
    id: number;
    name: string;
    email: string;
    role: string;
    is_active: boolean;
    selectedHierarchies: any[];
    selectedHierarchyIds: any[];
  };
}

export interface IState {
  pageSize: number;
  anchorEl: any;
  bag_inventory_data: any[];
  showDeleteBagModal: boolean;
  filter: any;
  status: any;
  listOfBarcode: any;
  showLoader: any;
  rowCount: any;
  bagsGiven: any;
  bagsGotBack: any;
  currentPage:number
}

class BagInventory extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
  constructor(props: RouteComponentProps & IProps & WithTranslation) {
    super(props);
    this.state = {
      pageSize: 10,
      anchorEl: null,
      bag_inventory_data: [],
      showDeleteBagModal: false,
      filter: '',
      status: 'all',
      listOfBarcode: '',
      showLoader: false,
      rowCount: 0,
      currentPage:0,
      bagsGiven: 0,
      bagsGotBack: 0,
    }
  }
  public componentDidMount(): void {
    this.fetchListofBarcodes();
    document.addEventListener("copy", this.handleClipboardCopy);
  }


  public handleClipboardCopy = (event: ClipboardEvent) => {
    event.preventDefault();
  
    const selection = window.getSelection();
    if (!selection) return;
  
    // Extract selected text
    const selectedText = selection.toString().trim();
  
    // If there's no selection, do nothing
    if (!selectedText) return;
  
    // Split the text into lines
    const lines = selectedText.split("\n").map(line => line.trim());
  
    // Group lines into records of 7 fields each
    const formattedText = [];
    for (let i = 0; i < lines.length; i += 7) {
      const record = lines.slice(i, i + 7).join("\t"); // Join 7 fields with tabs
      formattedText.push(record); // Add the formatted record to the array
    }
  
    // Join the records with new lines to keep each record on its own row
    const finalFormattedText = formattedText.join("\n");
  
    // Copy to clipboard
    event.clipboardData?.setData("text/plain", finalFormattedText);
  };
  

  public fetchListofBarcodes(page: any = 0, limit: number = this.state.pageSize) {
    this.setState({ showLoader: true ,currentPage:page});
    let data: any = {
      'hierarchies': this.props.user.selectedHierarchyIds,
      'filter': this.state.filter,
      'limit': limit,
      'page': page + 1
    }
    if(this.state.status == 'reached_warehouse'){
      data['reached_warehouse'] = "reached_warehouse";
    }else if(this.state.status == 'with_users'){
      data['user'] = "with_users";
    }
    axios.post('filterBarcodes', data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
      if (response.data.success) {
        this.setState({ showLoader: false });

        let bagData = response.data.data.data;
        let temp: any = [];
        bagData.map((el: any) => {
          temp.push({
            "id": el.id,
            "user_id": el.user_id,
            "name": el.user.name,
            "community_name": el.community_name,
            'barcode': el.barcode,
            'type': el.bag_type,
            'reached_warehouse': el.reached_warehouse ? "Yes" : "No",
            'created_at': el.created_at
          })
        });
        this.setState({ bag_inventory_data: temp, bagsGiven: response.data.msg[0], bagsGotBack: response.data.msg[1] });
        this.setState({ rowCount: response.data.data.total });

      } else {
        this.setState({ showLoader: false });
        toast.error(response.data.msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored"
        });
        let errors = response.data.errors;
        for (var error in errors) {
          toast.error(errors[error][0], {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored"
          });
        }
      }
    })

  }

  handleSearch = debounce((page: number = 0, limit: number = this.state.pageSize) => {
    this.fetchListofBarcodes(page, limit);
  }, 800);

  

  public render() {
    if (!localStorage.getItem('token')) {
      return (
        <Redirect to="/login" />
      );
    }
    const { t } = this.props;
    const open = Boolean(this.state.anchorEl);
    const renderMaskedCell = (value: React.ReactNode) => (
      <Box
        component="span"
        sx={isUatEnvironment ? {
          filter: 'blur(4px)',
          opacity: 0.5,
          userSelect: 'none',
        } : undefined}
      >
        {value}
      </Box>
    );

    const columns = [
      {
        headerName: "UserID",
        field: "user_id",
        width: 100,
        renderCell: (params: GridCellParams) => (
          <Typography
            sx={{ cursor: 'pointer'}}
            onClick={(e) => {
              e.stopPropagation();
              window.open('/neighbourhood/customers/' + params.row.user_id, '_blank');
            }}
            component={"span"}
          >
            {params.row.user_id}
          </Typography>
        )
      },
      {
        headerName: "Name",
        field: "name",
        width: 200,
        //   this.props.history.push('/neighbourhood/customers/' + params.row.user_id)
        renderCell: (params: GridCellParams) => (
          <Typography
            sx={{ cursor: 'pointer' }}
            // onClick={() => this.props.history.push('/neighbourhood/customers/' + params.row.user_id)}
              onClick={(e) => {
                e.stopPropagation();
                window.open('/neighbourhood/customers/' + params.row.user_id, '_blank');
              }}
              component={"span"}
            >
            {renderMaskedCell(params.row.name)}
          </Typography>
      )
      },
      {
        headerName: "Community",
        field: "community_name",
        width: 200,
        renderCell: (params: GridCellParams) =>
          renderMaskedCell(params.value),
      },
      {
        headerName: "Barcode",
        field: "barcode",
        width: 150,
      },
      {
        headerName: "Type",
        field: "type",
        width: 110,
      },
      {
        headerName: "Reached Warehouse",
        field: "reached_warehouse",
        width: 170,
      },
      {
        headerName: "Created At",
        field: "created_at",
        width: 180,
      }
    ];


    return (
      <div>
        <Backdrop
          sx={{ zIndex: (theme: any) => theme.zIndex.drawer + 1000 }}
          open={this.state.showLoader}
          // onClick={() => this.setState({ showLoader: false })}
        >
          <CircularProgress className='customLoader' />
        </Backdrop>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <OperationsHeader />
        <Grid container spacing={2}>
          <Grid item md={12} xs={12} className="mt-3">
            <Card style={{height: 650}}>
              <CardHeader
                title={
                  <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("List of Barcoded Bags")}</Typography>
                }
                action={
                  <CardActions className='float-right'>
                    <Stack direction="row" spacing={1}>
                      <Chip label={<Typography>Bags Given: <b>{this.state.bagsGiven.toLocaleString()}</b></Typography>} color='secondary' />
                      <Chip label={<Typography>Bags Got Back: <b>{this.state.bagsGotBack.toLocaleString()}</b></Typography>} color='success' />
                    </Stack>
                  </CardActions>
                }
                className="text-left"
              />
              <CardContent>
                <Grid container spacing={2} className='mb-2'>
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth={true} size="small">
                      <TextField
                        id="filter-input"
                        label={t("Search")}
                        name="filter"
                        value={this.state.filter}
                        onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.handleSearch())}
                        fullWidth={true}
                        size="small"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth={true} size="small" className="text-left">
                      <InputLabel id="route-type-label">{t("Type")}</InputLabel>
                      <Select
                        labelId="route-type-label"
                        value={this.state.status}
                        onChange={(e: any) => this.setState({ "status": e.target.value }, () => this.fetchListofBarcodes())}
                        displayEmpty
                        label={t("Status")}
                      >
                        <MenuItem key={'all'} value={'all'}>{t("All")}</MenuItem>
                        <MenuItem key={'reached_warehouse'} value={'reached_warehouse'}>{t("Reached Warehouse")}</MenuItem>
                        <MenuItem key={'with_users'} value={'with_users'}>{t("With Users")}</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  {/* <Grid item md={6} xs={12} className='text-right'>
                    <Button variant="contained" size="medium" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showDeleteBagModal: true })}>
                      Delete Bags Permanently
                    </Button>
                  </Grid> */}
                </Grid>
                <DataGrid
                  aria-label={t("List of Barcoded Bags")}
                  columns={columns}
                  rows={this.state.bag_inventory_data}
                  rowCount={this.state.rowCount}
                  pageSize={this.state.pageSize}
                  onPageChange={(page) => this.fetchListofBarcodes(page)}
                  onPageSizeChange={(newPageSize) => { this.setState({ pageSize: newPageSize }); this.fetchListofBarcodes(0, newPageSize); }}
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  // autoHeight={true}
                  style={{ height: 500 }}
                  pagination
                  components={{
                    MoreActionsIcon: EditOutlined,
                    Pagination: () => (
                      <CustomPagination
                          count={Math.ceil(this.state.rowCount / this.state.pageSize)}
                          page={this.state.currentPage+1}
                          onChange={(event, page) => this.fetchListofBarcodes(page-1)}
                        
                      />
                  )
                  }}
                  // onRowClick={(params: GridRowParams) => {
                  //   this.props.history.push('/neighbourhood/customers/' + params.row.user_id)
                  // }}
                  paginationMode="server"
                  disableVirtualization
                  // className="clickableList"
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withRouter(withTranslation()(BagInventory))
